import 'babel-polyfill';
import Vue from 'vue';
import App from '@/App';
import router from '@/router/router';
import Axios from 'axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueLocalStorage from 'vue-localstorage';
import '../static/style/theme/default.less';
import '../static/style/animate.css';
import '../static/fonts/font-awesome-4.7.0/css/font-awesome.min.css';
import '../static/style/common.less';

Vue.config.productionTip = false;
Vue.prototype.$http = Axios;
Vue.use(ElementUI);
Vue.use(VueLocalStorage);

let mainVue = new Vue({
  el: '#app',
  router,
  render: h => h(App),
  data: {
  },
  mounted () {

  }
});

Vue.use({
  mainVue
});



// WEBPACK FOOTER //
// ./src/main.js